import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import New from './New.svg';
import { APP_BACK, APPLE_SMALL, ARROW_DOWN, ARROW_UP, AUTO_OPEN, BACK, BLUE_ALERT, BLUE_CHECK, BLUE_CHECK_CIRCLE, BOT, BOX_STAR, CELEBRATE, CELEBRATION, CHEVRON_RIGHT_SMALL, CircleStarGray, CLOSE, CLOSE_BLACK, CLOSE_BLACK_SMALL, CLOSE_SMALL, COIN, COINS, COLORD_GIFT, COMMUNITY, COMPANY, COMPASS, COMPOSE, COPY, CREDIT_CARD, CREDIT_LIMIT, DASHBOARD, DASHBOARD_BLUE, DEFAULT_COMPANY_BIG, DISC, DOWN, DOWN_BLACK, DOWN_CHEVRON, EMPTY_LIST, ENRICH, ENRICH_HOVER, ENRICH_PRESSED, ERROR, EXTERNAL_GRAY_SMALL, EXTERNAL_LINK, FACEBOOK, FAIL_INDICATION, FEEDBACK_DEFAULT, FILTER, FILTERV2, FLAG, FLASHLIGHT, FREE_CREDITS, FREE_CREDITS_HOVER, FREE_CREDITS_PRESSED, FULL_LIST, FUNDING, GIFT, GLASSES, GLOBE, GLOBE_BLACK, GLOBE_BLUE, GMAIL, GMAIL_SIGNUP, GMAILV2, GOOGLE, GRAPH, HAND_SNAP, HELP, HISTORY_TAB, HISTORY_TAB_HOVER, HISTORY_TAB_PRESSED, HOURGLASS, IDLE, INDUSTRY, INFO, INFO_BLUE, INFO_FULL, INFO_STROKE, INTERCOM, INTERCOMSMALL, INVITE, LEFT, LIGHT_BULB, LIMIT_EXCEEDED, LINKEDIN, LINKEDIN_BLUE, LISTS, LOCATION, LUSHA, LUSHA_SCOUT_UPPER, MAGNIFYING_GLASS, MAIL, MAIL_BLACK, MICROSOFT_SMALL, MINIMIZE, MORE, MORE_HORIZONTAL, MORE_HOVER, MORE_PRESSED, MORE_RESULTS, NO_ENTRY, NO_PHONE, ONBOARDING, OUTER_LINK, OUTLOOK, PEOPLE, PLUG, PLUGIN_POSITION, PROFILE, PROSPECT, PROSPECT_HOVER, PROSPECT_PRESSED, REFER, REFRESH, REMOVE, REVEALED_TAG, RIGHT, RIGHT_ARROW, RIGHT_GRAY, RIGHT8X8, SAVE_MARK, SAVED_TAB, SAVED_TAB_HOVER, SAVED_TAB_PRESSED, SAVED_TAG, SCROLL, SEARCH, SEARCH_GRAY, SEARCH_HOVER, SEARCH_MORE_MENU, SEARCH_PRESSED, SEARCH_TOOLTIP, SEND, SETTINGS, SHEET, SLACK_SMALL, SOCIALS, STAR, SUCCESS_INDICATION, SUSPENDED, TAG_CONTACT, THUMBS_DOWN, THUMBS_DOWN_CHOSEN, THUMBS_UP, THUMBS_UP_CHOSEN, TIP, TWITTER, UP_CHEVRON, USER, WALLET_WARNING_SIGN, WEB, XPAPER, } from './iconsLinks';
export function IconFactory(icon) {
    switch (icon) {
        // Header Icons
        case 'Minimize':
            return _jsx("img", { src: MINIMIZE, alt: "Minimize" });
        case 'Close':
            return _jsx("img", { src: CLOSE, alt: "Close" });
        case 'Gift':
            return _jsx("img", { src: GIFT, alt: "Gift" });
        case 'User':
            return _jsx("img", { src: USER, alt: "User" });
        case 'Mail':
            return _jsx("img", { src: MAIL, alt: "Mail" });
        case 'AppBack':
            return _jsx("img", { src: APP_BACK, alt: "AppBack" });
        case 'CloseBlack':
            return _jsx("img", { src: CLOSE_BLACK, alt: "CloseBlack" });
        case 'CloseBlackSmall':
            return _jsx("img", { src: CLOSE_BLACK_SMALL, alt: "CloseBlackSmall" });
        // Footer Icons
        case 'Enrich':
            return _jsx("img", { src: ENRICH, alt: "Enrich" });
        case 'EnrichHover':
            return _jsx("img", { src: ENRICH_HOVER, alt: "Enrich Hover" });
        case 'EnrichPressed':
            return _jsx("img", { src: ENRICH_PRESSED, alt: "Enrich Pressed" });
        case 'Prospect':
            return _jsx("img", { src: PROSPECT, alt: "Prospect" });
        case 'ProspectHover':
            return _jsx("img", { src: PROSPECT_HOVER, alt: "ProspectHover" });
        case 'ProspectPressed':
            return _jsx("img", { src: PROSPECT_PRESSED, alt: "ProspectPressed" });
        case 'More':
            return _jsx("img", { src: MORE, alt: "More" });
        case 'MoreHover':
            return _jsx("img", { src: MORE_HOVER, alt: "MoreHover" });
        case 'MorePressed':
            return _jsx("img", { src: MORE_PRESSED, alt: "MorePressed" });
        case 'FreeCredits':
            return _jsx("img", { src: FREE_CREDITS, alt: "FreeCredits" });
        case 'FreeCreditsHover':
            return _jsx("img", { src: FREE_CREDITS_HOVER, alt: "FreeCreditsHover" });
        case 'FreeCreditsPressed':
            return _jsx("img", { src: FREE_CREDITS_PRESSED, alt: "FreeCreditsPressed" });
        case 'Search':
            return _jsx("img", { src: SEARCH, alt: "Search" });
        case 'SearchPressed':
            return _jsx("img", { src: SEARCH_PRESSED, alt: "Search Pressed" });
        case 'SearchHover':
            return _jsx("img", { src: SEARCH_HOVER, alt: "Search Hover" });
        case 'SearchTooltip':
            return _jsx("img", { src: SEARCH_TOOLTIP, alt: "Search Tooltip" });
        // More Menu Icons
        case 'Help':
            return _jsx("img", { src: HELP, alt: "Help" });
        case 'Invite':
            return _jsx("img", { src: INVITE, alt: "Invite" });
        case 'Lists':
            return _jsx("img", { src: LISTS, alt: "Lists" });
        case 'Plug':
            return _jsx("img", { src: PLUG, alt: "Plug" });
        case 'AutoOpen':
            return _jsx("img", { src: AUTO_OPEN, alt: "AutoOpen" });
        case 'Dashboard':
            return _jsx("img", { src: DASHBOARD, alt: "Dashboard" });
        case 'OuterLink':
            return _jsx("img", { src: OUTER_LINK, alt: "OuterLink" });
        case 'Refer':
            return _jsx("img", { src: REFER, alt: "Refer" });
        case 'Settings':
            return _jsx("img", { src: SETTINGS, alt: "Settings" });
        case 'PluginPosition':
            return _jsx("img", { src: PLUGIN_POSITION, alt: "PluginPosition" });
        case 'GlobeBlack':
            return _jsx("img", { src: GLOBE_BLACK, alt: "GlobeBlack" });
        case 'SearchMoreMenu':
            return _jsx("img", { src: SEARCH_MORE_MENU, alt: "SearchMoreMenu" });
        case 'Community':
            return _jsx("img", { src: COMMUNITY, alt: "Community" });
        case 'Profile':
            return _jsx("img", { src: PROFILE, alt: "Profile" });
        // Contact details Icons
        case 'FeedbackDefault':
            return _jsx("img", { src: FEEDBACK_DEFAULT, alt: "Feedback Default" });
        case 'ThumbsDown':
            return _jsx("img", { src: THUMBS_DOWN, alt: "Thumbs Down" });
        case 'ThumbsUp':
            return _jsx("img", { src: THUMBS_UP, alt: "Thumbs Up" });
        case 'ThumbsDownChosen':
            return _jsx("img", { src: THUMBS_DOWN_CHOSEN, alt: "Thumbs Down Chosen" });
        case 'ThumbsUpChosen':
            return _jsx("img", { src: THUMBS_UP_CHOSEN, alt: "Thumbs Up Chosen" });
        case 'Copy':
            return _jsx("img", { src: COPY, alt: "Copy" });
        case 'DownBlack':
            return _jsx("img", { src: DOWN_BLACK, alt: "Down Black" });
        case 'SearchGray':
            return _jsx("img", { src: SEARCH_GRAY, alt: "Search Gray" });
        case 'ExternalGraySmall':
            return _jsx("img", { src: EXTERNAL_GRAY_SMALL, alt: "External Gray Small" });
        case 'NoPhone':
            return _jsx("img", { src: NO_PHONE, alt: "No Phone" });
        case 'noEntry':
            return _jsx("img", { src: NO_ENTRY, alt: "No Entry" });
        // Company Data Icons
        case 'Info':
            return _jsx("img", { src: INFO, alt: "Info" });
        case 'InfoFull':
            return _jsx("img", { src: INFO_FULL, alt: "Info Full" });
        case 'InfoStroke':
            return _jsx("img", { src: INFO_STROKE, alt: "Info Stroke" });
        case 'People':
            return _jsx("img", { src: PEOPLE, alt: "People" });
        case 'Industry':
            return _jsx("img", { src: INDUSTRY, alt: "Industry" });
        case 'Flag':
            return _jsx("img", { src: FLAG, alt: "Flag" });
        case 'Graph':
            return _jsx("img", { src: GRAPH, alt: "Graph" });
        case 'Location':
            return _jsx("img", { src: LOCATION, alt: "Location" });
        case 'Globe':
            return _jsx("img", { src: GLOBE, alt: "Globe" });
        case 'Socials':
            return _jsx("img", { src: SOCIALS, alt: "Socials" });
        case 'Facebook':
            return _jsx("img", { src: FACEBOOK, alt: "Facebook" });
        case 'Twitter':
            return _jsx("img", { src: TWITTER, alt: "Twitter" });
        case 'Linkedin':
            return _jsx("img", { src: LINKEDIN, alt: "Linkedin" });
        case 'Web':
            return _jsx("img", { src: WEB, alt: "Web" });
        case 'Company':
            return _jsx("img", { src: COMPANY, alt: "Company" });
        case 'Glasses':
            return _jsx("img", { src: GLASSES, alt: "Glasses" });
        case 'Back':
            return _jsx("img", { src: BACK, alt: "Back" });
        case 'Down':
            return _jsx("img", { src: DOWN, alt: "Down" });
        case 'Idle':
            return _jsx("img", { src: IDLE, alt: "Idle" });
        case 'Lusha':
            return _jsx("img", { src: LUSHA, alt: "Lusha" });
        case 'Google':
            return _jsx("img", { src: GOOGLE, alt: "Google" });
        case 'Intercom':
            return _jsx("img", { src: INTERCOM, alt: "Intercom" });
        case 'AppleSmall':
            return _jsx("img", { src: APPLE_SMALL, alt: "Apple Small" });
        case 'IntercomSmall':
            return _jsx("img", { src: INTERCOMSMALL, alt: "Intercom Small" });
        case 'MicrosoftSmall':
            return _jsx("img", { src: MICROSOFT_SMALL, alt: "Microsoft Small" });
        case 'SlackSmall':
            return _jsx("img", { src: SLACK_SMALL, alt: "Slack Small" });
        case 'funding':
            return _jsx("img", { src: FUNDING, alt: "funding small" });
        // Notifications
        case 'SuccessIndication':
            return _jsx("img", { src: SUCCESS_INDICATION, alt: "Success Indication" });
        case 'FailIndication':
            return _jsx("img", { src: FAIL_INDICATION, alt: "Fail Indication" });
        case 'BlueFailIndication':
            return _jsx("img", { src: BLUE_ALERT, alt: "Blue Alert Indication" });
        case 'InfoIndication':
            return _jsx("img", { src: INFO_BLUE, alt: "Info Blue" });
        case 'Remove':
            return _jsx("img", { src: REMOVE, alt: "Remove" });
        // Compose
        case 'Coin':
            return _jsx("img", { src: COIN, alt: "Coin" });
        case 'Gmail':
            return _jsx("img", { src: GMAIL, alt: "Gmail" });
        case 'GmailV2':
            return _jsx("img", { src: GMAILV2, alt: "GmailV2" });
        case 'Outlook':
            return _jsx("img", { src: OUTLOOK, alt: "Outlook" });
        case 'MoreHorizontal':
            return _jsx("img", { src: MORE_HORIZONTAL, alt: "More Horizontal" });
        case 'Send':
            return _jsx("img", { src: SEND, alt: "Send" });
        case 'Left':
            return _jsx("img", { src: LEFT, alt: "Left" });
        case 'Compose':
            return _jsx("img", { src: COMPOSE, alt: "Compose" });
        // Integrations
        case 'SaveMark':
            return _jsx("img", { src: SAVE_MARK, alt: "Save Mark" });
        case 'SavedTab':
            return _jsx("img", { src: SAVED_TAB, alt: "Saved Tab" });
        case 'SavedTabPressed':
            return _jsx("img", { src: SAVED_TAB_PRESSED, alt: "Saved Tab Pressed" });
        case 'SavedTabHover':
            return _jsx("img", { src: SAVED_TAB_HOVER, alt: "Saved Tab Hover" });
        case 'EmptyList':
            return _jsx("img", { src: EMPTY_LIST, alt: "Empty Table" });
        case 'historyTabHover':
            return _jsx("img", { src: HISTORY_TAB_HOVER, alt: "history Tab Hover" });
        case 'historyTabPressed':
            return _jsx("img", { src: HISTORY_TAB_PRESSED, alt: "history Tab pressed" });
        case 'historyTab':
            return _jsx("img", { src: HISTORY_TAB, alt: "history Tab" });
        // Account Suspence
        case 'Suspended':
            return _jsx("img", { src: SUSPENDED, alt: "Suspended" });
        case 'LimitExceeded':
            return _jsx("img", { src: LIMIT_EXCEEDED, alt: "LimitExceeded" });
        case 'CreditCard':
            return _jsx("img", { src: CREDIT_CARD, alt: "CreditCard" });
        case 'Hourglass':
            return _jsx("img", { src: HOURGLASS, alt: "Hourglass" });
        // Maintenance
        case 'Refresh':
            return _jsx("img", { src: REFRESH, alt: "Refresh" });
        // Out of Credits
        case 'CreditLimit':
            return _jsx("img", { src: CREDIT_LIMIT, alt: "CreditLimit" });
        case 'WalletWarningSign':
            return _jsx("img", { src: WALLET_WARNING_SIGN, alt: "WalletWarningSign" });
        // Onboarding
        case 'Onboarding':
            return _jsx("img", { src: ONBOARDING, alt: "Onboarding" });
        case 'MagnifyingGlass':
            return _jsx("img", { src: MAGNIFYING_GLASS, alt: "Magnifying Glass" });
        // Error Boundary
        case 'Error':
            return _jsx("img", { src: ERROR, alt: "Error" });
        // Bot detection
        case 'Bot':
            return _jsx("img", { src: BOT, alt: "Bot" });
        // Prospecting
        case 'FlashLight':
            return _jsx("img", { src: FLASHLIGHT, alt: "Flash Light" });
        case 'DefaultCompanyBig':
            return _jsx("img", { src: DEFAULT_COMPANY_BIG, alt: "Default Company Big" });
        case 'Filter':
            return _jsx("img", { src: FILTER, alt: "Filter" });
        case 'FilterV2':
            return _jsx("img", { src: FILTERV2, alt: "FilterV2" });
        case 'MoreResults':
            return _jsx("img", { src: MORE_RESULTS, alt: "MoreResults" });
        case 'Revealed':
            return _jsx("img", { src: REVEALED_TAG, alt: "Revealed" });
        case 'Saved':
            return _jsx("img", { src: SAVED_TAG, alt: "Saved" });
        // Bulk
        case 'Scroll':
            return _jsx("img", { src: SCROLL, alt: "Scroll" });
        case 'ExternalLink':
            return _jsx("img", { src: EXTERNAL_LINK, alt: "External Link" });
        // Toolbar
        case 'DashboardBlue':
            return _jsx("img", { src: DASHBOARD_BLUE, alt: "Dashboard Blue" });
        case 'LinkedinBlue':
            return _jsx("img", { src: LINKEDIN_BLUE, alt: "Linkedin Blue" });
        case 'GlobeBlue':
            return _jsx("img", { src: GLOBE_BLUE, alt: "Globe Blue" });
        case 'GmailSignup':
            return _jsx("img", { src: GMAIL_SIGNUP, alt: "Gmail Signup" });
        // FreeTrialStarted
        case 'Compass':
            return _jsx("img", { src: COMPASS, alt: "Compass" });
        case 'Disc':
            return _jsx("img", { src: DISC, alt: "Disc" });
        case 'Sheet':
            return _jsx("img", { src: SHEET, alt: "Sheet" });
        // Refer a friend
        case 'BoxStar':
            return _jsx("img", { src: BOX_STAR, alt: "Box Star", width: 74, height: 74 });
        case 'MailBlack':
            return _jsx("img", { src: MAIL_BLACK, alt: "Mail Black" });
        case 'Celebration':
            return _jsx("img", { src: CELEBRATION, alt: "Celebration", width: 74 });
        // Arrows and Chevrons
        case 'Right8x8':
            return _jsx("img", { src: RIGHT8X8, alt: "Right" });
        case 'ArrowUp':
            return _jsx("img", { src: ARROW_UP, alt: "Arrow Up" });
        case 'ArrowDown':
            return _jsx("img", { src: ARROW_DOWN, alt: "Arrow Down" });
        case 'ChevronRightSmall':
            return _jsx("img", { src: CHEVRON_RIGHT_SMALL, alt: "Chevron Right Small" });
        case 'Right':
            return _jsx("img", { src: RIGHT, alt: "Right" });
        case 'RightGray':
            return _jsx("img", { src: RIGHT_GRAY, alt: "Right Gray" });
        case 'UpChevron8x8':
            return _jsx("img", { src: UP_CHEVRON, alt: "Up Chevron" });
        case 'DownChevron8x8':
            return _jsx("img", { src: DOWN_CHEVRON, alt: "Down Chevron" });
        case 'RightArrow':
            return _jsx("img", { src: RIGHT_ARROW, alt: "Right Arrow" });
        // Miscellaneous
        case 'LushaScoutUpper':
            return _jsx("img", { src: LUSHA_SCOUT_UPPER, alt: "Lusha Scout Upper" });
        case 'XPaper':
            return _jsx("img", { src: XPAPER, alt: "XPaper" });
        case 'LightBulb':
            return _jsx("img", { src: LIGHT_BULB, alt: "Light Bulb" });
        case 'New':
            return _jsx(New, {});
        case 'HandSnap':
            return _jsx("img", { src: HAND_SNAP, alt: "HandSnap" });
        case 'InfoBlue':
            return _jsx("img", { src: INFO_BLUE, alt: "InfoBlue" });
        case 'Celebrate':
            return _jsx("img", { src: CELEBRATE, alt: "Celebrate" });
        case 'Tip':
            return _jsx("img", { src: TIP, alt: "Tip" });
        case 'CloseSmall':
            return _jsx("img", { src: CLOSE_SMALL, alt: "CloseSmall" });
        case 'FullList':
            return _jsx("img", { src: FULL_LIST, alt: "FullList" });
        case 'Star':
            return _jsx("img", { src: STAR, alt: "Star" });
        case 'BlueCheck':
            return _jsx("img", { src: BLUE_CHECK, alt: "BlueCheck" });
        case 'BlueCheckWithCircle':
            return _jsx("img", { src: BLUE_CHECK_CIRCLE, alt: "BlueCheckWithCircle" });
        case 'Coins':
            return _jsx("img", { src: COINS, alt: "Coins" });
        case 'ColoredGift':
            return _jsx("img", { src: COLORD_GIFT, alt: "ColoredGift" });
        // Tags
        case 'TagContact':
            return _jsx("img", { src: TAG_CONTACT, alt: "TagContact", height: 40, width: 40 });
        // Credit
        case 'Credit':
            return _jsx("img", { src: CircleStarGray, alt: "Credit" });
        default:
            return null;
    }
}
